import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import Close from 'assets/close.svg';
import { useTranslation } from 'next-i18next';
import FormModule from '@/modules/FormModule';
import { ModalPortal } from '@/components';
// import { colorFromBgColor } from '@/utils';

const FormPopupStatic = ({ form, popupId }) => {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [closeDelay, setCloseDelay] = useState(false);
  const { t } = useTranslation('common');

  useEffect(() => {
    if (!form) return;

    if (router.query.form && router.query.id == form?.formFields.id && router.query.popupId === popupId) {
      setOpen(true);
      setCloseDelay(true);
    } else {
      setOpen(false);
      const timer = setTimeout(() => {
        setCloseDelay(false);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [form, router.asPath, form?.formFields.id, router.query.form, router.query.id, router.query.popupId, popupId]);

  const handleClose = () => {
    const query = { ...router.query };
    delete query.form;
    delete query.popupId;
    delete query.id;
    router.replace(
      {
        query,
      },
      undefined,
      { shallow: true },
    );
    setOpen(false);
  };

  return (
    <ModalPortal>
      <div className={classNames('', open ? 'h-dvh lg:h-screen disable-scroll' : 'h-0')} />
      <div
        className={classNames(
          'bg-[url("/images/caja-form-bg.jpg")] bg-cover fixed top-0 left-0 z-40 w-screen transition-opacity duration-500',
          open ? ' h-screen opacity-100' : 'h-0 opacity-0 ',
        )}
      />

      <div
        className={classNames(
          'fixed top-[50%] left-[50%] -translate-y-1/2 -translate-x-1/2 z-50 transition-opacity duration-500 w-screen flex lg:justify-start justify-center items-center overflow-hidden',
          'xl:p-16 lg:p-12 md:p-8 p-4',
          open ? 'opacity-1  pointer-events-auto' : 'opacity-0 pointer-events-none',
          closeDelay ? 'max-h-[calc(100vh-100px)] lg:h-fit' : 'h-0',
        )}
        onClick={handleClose}
      >
        <div
          className={classNames(
            'max-h-[calc(100vh-100px)] sm:h-fit md:w-[75%] w-full rounded-contact relative flex flex-col justify-between items-center shrink-0 overflow-auto',
            'bg-[rgba(0,0,0,0.5)]',
          )}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <button
            onClick={handleClose}
            className={`btn absolute right-0 top-0 p-4 h-auto bg-transparent`}
            aria-label={t('general.$close')}
          >
            <Close className="stroke-brand-soft-white w-6 h-6" />
          </button>

          <div className="flex flex-col gap-8 items-center w-full px-10 py-8 lg:py-12">
            {form && <FormModule data={form} isPopup={true} />}
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default FormPopupStatic;
